module.exports = __webpack_public_path__ + "img/axle_conf_5.152f4fc0.jpg";